import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { Input, Button } from "antd";
import { urlPath, devMode } from "./Settings";
import { getAuthHeader } from "../utils/security";
import { connect } from "react-redux";
import { setFieldsToSave, setMatspecsToSubmit } from "../redux/actions";

const { TextArea } = Input;

const mapDispatchToProps = (dispatch) => {
    return {
        setFieldsToSave: (key) => dispatch(setFieldsToSave(key)),
        setMatspecsToSubmit: (key) => dispatch(setMatspecsToSubmit(key)),
    };
};

const mapStateToProps = (state) => {
    return {
        fieldsToSave: state.fieldsToSave,
        matspecsToSubmit: state.matspecsToSubmit,
    };
};

/* eslint no-array-constructor: 0 */
/* eslint no-cond-assign: 0 */
class MatspecHeader extends Component {
    constructor(props) {
        super(props);
        const config = this.props.config ? this.props.config : "";
        const creativesLength = this.props.creativesLength;
        const creativesToReview = this.props.creativesToReview;
        const currentMatspec = this.props.currentMatspec;
        const statuses = this.props.statuses;
        /* let translateHeaderConfig = this.props.currentMatspec.printed
      ? config.matspecHeaderPrint
      : config.matspecHeader; */

        let translateHeaderConfig =
            this.props.currentTabKey === "print" ||
            (this.props.singleAd && currentMatspec.printed)
                ? config.matspecHeaderPrint
                : config.matspecHeader;
        var found = [], // an array to collect the strings that are found
            rxp = /{([^}]+)}/g,
            str = translateHeaderConfig,
            curMatch;

        while ((curMatch = rxp.exec(str))) {
            found.push(curMatch[1]);
        }

        // console.log("found", found);
        for (let i = 0; i < found.length; i++) {
            let match = found[i];
            if (match.includes("MaterialSpecification.")) {
                match = match.replace("MaterialSpecification.", "");
                if (match === "select") {
                    translateHeaderConfig = translateHeaderConfig.replace("{MaterialSpecification." + match + "}", 'checkbox')
                } else if (currentMatspec[match]) {
                    if (match === "status") {
                        // console.log(match)
                        translateHeaderConfig = translateHeaderConfig.replace(
                            "{MaterialSpecification." + match + "}",
                            "<span style='border-radius:3px;padding: 1px 6px;margin:0 5px;background-color:" +
                                currentMatspec.status["color"] +
                                "50" +
                                ";border:1px solid " +
                                currentMatspec.status["color"] +
                                "'>" +
                                statuses.data[currentMatspec.status["code"]]
                                    .text +
                                "</span>"
                        );
                    } else if (match === "productioncode") {
                        translateHeaderConfig = translateHeaderConfig.replace(
                            "{MaterialSpecification." + match + "}",
                            currentMatspec[match].name
                        );
                    } else if (match === "type") {
                        translateHeaderConfig = translateHeaderConfig.replace(
                            "{MaterialSpecification." + match + "}",
                            currentMatspec.printed
                                ? this.props.translations.print
                                : this.props.translations.digital
                        );
                    } else {
                        translateHeaderConfig = translateHeaderConfig.replace(
                            "{MaterialSpecification." + match + "}",
                            currentMatspec[match]
                        );
                    }
                } else {
                    translateHeaderConfig = translateHeaderConfig.replace(
                        "{MaterialSpecification." + match + "}",
                        ""
                    );
                }
            } else if (match.includes("Insertion.")) {
                match = match.replace("Insertion.", "");
                if (currentMatspec.insertions[0][match]) {
                    if (match.includes("placement")) {
                        translateHeaderConfig = translateHeaderConfig.replace(
                            "{Insertion." + match + "}",
                            currentMatspec.insertions[0][match].name
                        );
                    } else {
                        translateHeaderConfig = translateHeaderConfig.replace(
                            "{Insertion." + match + "}",
                            currentMatspec.insertions[0][match]
                        );
                    }
                } else {
                    translateHeaderConfig = translateHeaderConfig.replace(
                        "{Insertion." + match + "}",
                        ""
                    );
                }
            } else if (
                match.includes("notCompletedCreatives") ||
                match.includes("totalCreatives")
            ) {
                translateHeaderConfig = translateHeaderConfig
                    .replace("{notCompletedCreatives}", creativesToReview)
                    .replace("{totalCreatives}", creativesLength);
            } else {
                translateHeaderConfig = translateHeaderConfig.replace(
                    "{" + match + "}",
                    this.props.translations[match]
                );
            }
        }
        //console.log("translateHeaderConfig", translateHeaderConfig);

        translateHeaderConfig = translateHeaderConfig
            .replace("<span><span", "<span")
            .replace("</span></span>", "</span>");
        translateHeaderConfig = ReactHtmlParser(translateHeaderConfig);

        const htmlArray = new Array();
        const htmlArrayRender = new Array();
        for (let i = 0; i < translateHeaderConfig.length; i++) {
            const currentHTML = translateHeaderConfig[i];
            if (
                currentHTML !== null &&
                typeof currentHTML === "object" &&
                currentHTML.props &&
                currentHTML.props.children[0] &&
                currentHTML.props.children[0].length > 0
            ) {
                const text = [currentHTML.props.children[0]];
                htmlArray.push({
                    style: currentHTML.props.style,
                    text,
                    //text: currentHTML.props.children[0]
                });
            } else {
                if (typeof currentHTML === "object")
                    htmlArray.push({
                        style: undefined,
                        text: ["N/A"],
                        //text: currentHTML.props.children[0]
                    });
            }
        }
        //console.log("htmlArray", htmlArray);
        for (let i = 0; i < htmlArray.length; i++) {
            let text = htmlArray[i].text;
            const style = htmlArray[i].style;
            htmlArrayRender.push(
                <span
                    data-statuscode={currentMatspec.status.code}
                    key={i}
                    style={style}
                >
                    <span className="matspecHeader--title">{text[0]}</span>
                    <span className="matspecHeader--value">{text[1]}</span>
                </span>
            );
        }
        this.state = {
            config: config,
            creativesLength: creativesLength,
            creativesToReview: creativesToReview,
            currentMatspec: currentMatspec,
            matspecHeaderHTML: htmlArrayRender,
            noteText: currentMatspec.customernote,
            shouldBeDisabled: this.props.multiUploadChecked,
        };
    }


    runMatspecHeader(prevProps = this.props, nextProps){
        //console.log(prevProps, nextProps);
        const config = this.props.config ? this.props.config : "";
        const creativesLength = this.props.creativesLength;
        const creativesToReview = this.props.creativesToReview;
        const currentMatspec = this.props.currentMatspec;
        const statuses = prevProps.statuses;

        /* let translateHeaderConfig = this.props.currentMatspec.printed
      ? config.matspecHeaderPrint
      : config.matspecHeader; */
        let translateHeaderConfig =
            prevProps.currentTabKey === "print" ||
            (this.props.singleAd && currentMatspec.printed)
                ? config.matspecHeaderPrint
                : config.matspecHeader;

        var found = [], // an array to collect the strings that are found
            rxp = /{([^}]+)}/g,
            str = translateHeaderConfig,
            curMatch;

        while ((curMatch = rxp.exec(str))) {
            found.push(curMatch[1]);
        }
        //console.log( found );

        for (let i = 0; i < found.length; i++) {
            let match = found[i];
            if (match.includes("MaterialSpecification.")) {
                match = match.replace("MaterialSpecification.", "");
                if (match === "select") {
                    translateHeaderConfig = translateHeaderConfig.replace("{MaterialSpecification." + match + "}", 'checkbox')
                } else if (currentMatspec[match]) {
                    if (match === "status") {
                        //console.log(match)
                        //console.log(translateHeaderConfig)
                        translateHeaderConfig = translateHeaderConfig.replace(
                            "{MaterialSpecification." + match + "}",
                            "<span style='border-radius:3px;padding: 1px 6px;margin:0 5px;background-color:" +
                                currentMatspec.status["color"] +
                                "50" +
                                ";border:1px solid " +
                                currentMatspec.status["color"] +
                                "'>" +
                                statuses.data[currentMatspec.status["code"]]
                                    .text +
                                "</span>"
                        );
                        //console.log(translateHeaderConfig)
                    } else if (
                        match === "productioncode" &&
                        currentMatspec[match].name
                    ) {
                        translateHeaderConfig = translateHeaderConfig.replace(
                            "{MaterialSpecification." + match + "}",
                            currentMatspec[match].name
                        );
                    } else if (match === "type") {
                        translateHeaderConfig = translateHeaderConfig.replace(
                            "{MaterialSpecification." + match + "}",
                            currentMatspec.printed
                                ? this.props.translations.print
                                : this.props.translations.digital
                        );
                    } else {
                        translateHeaderConfig = translateHeaderConfig.replace(
                            "{MaterialSpecification." + match + "}",
                            currentMatspec[match]
                        );
                    }
                } else {
                    translateHeaderConfig = translateHeaderConfig.replace(
                        "{MaterialSpecification." + match + "}",
                        ""
                    );
                }
            } else if (match.includes("Insertion.")) {
                match = match.replace("Insertion.", "");
                if (currentMatspec.insertions[0][match]) {
                    if (match.includes("placement")) {
                        translateHeaderConfig = translateHeaderConfig.replace(
                            "{Insertion." + match + "}",
                            currentMatspec.insertions[0][match].name
                        );
                    } else {
                        translateHeaderConfig = translateHeaderConfig.replace(
                            "{Insertion." + match + "}",
                            currentMatspec.insertions[0][match]
                        );
                    }
                } else {
                    translateHeaderConfig = translateHeaderConfig.replace(
                        "{Insertion." + match + "}",
                        ""
                    );
                }
            } else if (
                match.includes("notCompletedCreatives") ||
                match.includes("totalCreatives")
            ) {
                translateHeaderConfig = translateHeaderConfig
                    .replace("{notCompletedCreatives}", creativesToReview)
                    .replace("{totalCreatives}", creativesLength);
            } else {
                if (this.props.translations[match])
                    translateHeaderConfig = translateHeaderConfig.replace(
                        "{" + match + "}",
                        this.props.translations[match]
                    );
                else
                    translateHeaderConfig = translateHeaderConfig.replace(
                        "{" + match + "}",
                        match
                    );
            }
        }
        translateHeaderConfig = translateHeaderConfig
            .replace("<span><span", "<span")
            .replace("</span></span>", "</span>");
        translateHeaderConfig = ReactHtmlParser(translateHeaderConfig);

        const htmlArray = new Array();
        const htmlArrayRender = new Array();
        for (let i = 0; i < translateHeaderConfig.length; i++) {
            //console.log('translateHeaderConfig' , translateHeaderConfig)
            const currentHTML = translateHeaderConfig[i];
            if (
                currentHTML !== null &&
                typeof currentHTML === "object" &&
                currentHTML.props &&
                currentHTML.props.children[0] &&
                currentHTML.props.children[0].length > 0
            ) {
                const text = [currentHTML.props.children[0]];
                htmlArray.push({
                    style: currentHTML.props.style,
                    text,
                    //text: currentHTML.props.children[0]
                });
            } else {
                if (typeof currentHTML === "object") {
                    htmlArray.push({
                        style: undefined,
                        text: ["N/A"],
                        //text: currentHTML.props.children[0]
                    });
                }
                    
            }
        }
        //console.log("htmlArray", htmlArray);
        for (let i = 0; i < htmlArray.length; i++) {
            let text = htmlArray[i].text;
            const style = htmlArray[i].style;

            if (text[0].toLowerCase() === "checkbox") {
                htmlArrayRender.push(
                    <span
                        data-statuscode={currentMatspec.status.code}
                        key={i}
                        style={style}
                    >
                        <input type="checkbox" 
                            checked={prevProps.checkedMatspecsArray.find((id) => id === currentMatspec.id) !== undefined}
                            disabled={prevProps.multiUploadChecked}
                            onClick={(e) => {
                                this.props.handleMatSpecCheck(currentMatspec.id);
                                e.stopPropagation();
                            }} 
                        />
                    </span>
                )
            } else {
                htmlArrayRender.push(
                    <span
                        data-statuscode={currentMatspec.status.code}
                        key={i}
                        style={style}
                    >
                        <span className="matspecHeader--title">{text[0]}</span>
                        <span className="matspecHeader--value">{text[1]}</span>
                    </span>
                );
            }
        }
        let materialStatuses = currentMatspec.admaterial.map((item) =>
            item.dummy ? null : item.status.code
        );
        materialStatuses = materialStatuses.filter((item) => item !== null);
        //console.log('materialStatuses', materialStatuses)
        let counts = {};
        materialStatuses.forEach(function(x) {
            counts[x] = (counts[x] || 0) + 1;
        });
        counts = Object.entries(counts);
        const countsList = counts.map(
            (item, index) =>
                item[0] !== "undefined" && (
                    <li
                        style={{
                            display: "inline-block",
                            marginRight: "10px",
                        }}
                        key={index}
                    >
                        <span
                            style={{
                                background: statuses.data[item[0]].color + 75,
                                padding: "2px 3px",
                                borderRadius: "3px",
                            }}
                        >
                            {statuses.data[item[0]].text} ({item[1]})
                        </span>
                    </li>
                )
        );
        const countsListStyle = {
            padding: 0,
            fontWeight: "normal",
            listStyle: "none",
        };
        /*
    if (config["web.campaign.creativestatuscount"])
      htmlArrayRender.push(
        <ul key={Math.random()} style={countsListStyle}>
          {countsList}
        </ul>
      );
      */
        if (config["web.campaign.creativestatuscount"])
            this.setState({ countsList });
        this.setState({
            matspecHeaderHTML: htmlArrayRender,
        });

    }
    componentWillReceiveProps(prevProps, nextProps) {
        this.runMatspecHeader(prevProps, nextProps)
    }
    componentWillMount() {
        this.runMatspecHeader()
    }


    handleTextarea = (e) => {
        const value = e.target.value;
        const { currentMatspec } = this.props;
        this.setState({ noteText: value });
        this.setState({
            noteToSave: {
                service: "matspecupdate",
                target: "matspec",
                id: currentMatspec.id,
                field: "customernote",
                value,
            },
        });
        /* setTimeout(() => {
            //console.log("Input Value:", value);
            this.saveField(
                "matspecupdate",
                "matspec",
                currentMatspec.id,
                "customernote",
                value
            );
        }, 1000); */
    };

    saveNote = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (this.state.noteToSave) {
            const { service, target, id, field, value } = this.state.noteToSave;
            this.saveField(service, target, id, field, value);
            this.props.setMatspecsToSubmit({
                ...this.props.matspecsToSubmit,
                [id]: true,
            });
        } else {
            console.log("no change");
        }
    };
    saveField = (service, target, id, field, value) => {
        fetch(
            urlPath +
                "/api/" +
                service +
                "?" +
                target +
                "=" +
                id +
                "&" +
                field +
                "=" +
                encodeURIComponent(value),
            { method: "PUT", credentials: "include", headers: getAuthHeader() }
        )
            .then((response) => response.json())
            .then((data) =>
                console.log(
                    "Service: " +
                        service +
                        "target: " +
                        target +
                        "id: " +
                        id +
                        "Service: " +
                        id +
                        "field: " +
                        field +
                        "value: " +
                        value
                )
            )
            .catch((e) => console.error("Cannot update material", e));
    };
    handleKeyPress = (event) => {
        if (event.key == "Enter") event.stopPropagation();
    };
    render() {
        const { matspecHeaderHTML, config, countsList } = this.state;
        return (
            <div className="matspec-header">
                <span
                    id="matspecHeaderContent"
                    className="matspec-header-content"
                >
                    {matspecHeaderHTML}
                </span>
                <div>{countsList}</div>
                {(devMode || config["web.matspecheader.notefield"]) && (
                    <div className="matspecHeader-notes">
                        <label data-translationkey="notes">
                            {this.props.translations.customerNotes}
                        </label>
                        <TextArea
                            placeholder={this.props.translations.enterNote}
                            rows={1}
                            onClick={(e) => e.stopPropagation()}
                            value={this.state.noteText}
                            onChange={this.handleTextarea}
                            onKeyPress={this.handleKeyPress}
                            style={{ 'whiteSpace': 'pre-wrap' }}
                        />
                        <Button
                            style={{marginLeft: '5px'}}
                            onClick={(e) => this.saveNote(e)}
                            type="primary"
                        >
                            {this.props.translations.save}
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MatspecHeader);



// WEBPACK FOOTER //
// ./src/components/MatspecHeader.js